import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service/auth.service';
import { LoadingService } from '../services/loading-service/loading-service.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
    public _loading: LoadingService,
    @Inject('AuthService') public authService: AuthService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (!request.reportProgress) this._loading.set();

    //set Authentication Header only in /api/ call.
    if (request.url.toString().startsWith(environment.apiBaseUrl) && this.authService.isUserLoggedIn() && (this.authService.isSessionExpiryValid() || this.authService.isSessionExpiryNull())) {
      return next.handle(request).pipe(
        tap((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            let expire = evt.headers.get('Session-Expiry');
            if (expire != null && expire != undefined) {
              this.authService.setSessionExpiry(Number(expire))
            }
            this._loading.decrement();
          }
        }, (err: any) => this._loading.decrement())
      )
    } else if (this.authService.isUserLoggedIn() && !this.authService.isSessionExpiryValid()) {
      this.authService.goToLogout()
      return of(null)
    }
    else { //user is not logged in but still can perform actions
      return next.handle(request).pipe(catchError((err: any) => {
        this._loading.decrement();
        return err;
      }))
        .pipe(map<any, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            this._loading.decrement();
          }
          return evt;
        }));
    }
  }
}
